"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_TYPE = exports.TAG = exports.MARGIN = exports.ICON_TYPE = exports.ICONS = exports.ANCILLARY_TYPE_ICONS = void 0;
var ICONS = {
  EXPAND_MORE_ICON: 'ExpandMoreIcon',
  EXPAND_LESS_ICON: 'ExpandLessIcon'
};
exports.ICONS = ICONS;
var TRANSLATION = {
  to: 'to'
};
exports.TRANSLATION = TRANSLATION;
var TEXT_TYPE = {
  normal: {
    type: 'textNormal',
    color: 'neutral'
  },
  light: {
    type: 'textNormal',
    color: 'greyDark'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var ICON_TYPE = {
  normal: {
    color: 'greyDark',
    size: 'titleSmall'
  },
  neutral: {
    color: 'neutral',
    size: 'titleSmall'
  }
};
exports.ICON_TYPE = ICON_TYPE;
var TAG = {
  div: 'div'
};
exports.TAG = TAG;
var MARGIN = {
  micro: 'micro'
};
exports.MARGIN = MARGIN;
var ANCILLARY_TYPE_ICONS = {
  flightBaggageItem: 'LargeBaggage',
  flightInsuranceItem: 'SecurityIcon'
};
exports.ANCILLARY_TYPE_ICONS = ANCILLARY_TYPE_ICONS;